import { formatTime } from 'helper/time';
import { useSelector } from 'react-redux';
import { getTimePatternWithSeconds } from 'store/slices/userSettingsSlice';

import styles from './Clock.module.scss';

interface ClockProps {
    datetime: Date;
}
const Clock = ({ datetime }: ClockProps) => {
    const timePattern = useSelector(getTimePatternWithSeconds);

    return (
        <div
            data-testid='clock'
            className={`${styles.Clock} display-flex w-fit align-items-center gap-10 bg-white p-10 text-left font-body text-14 text-gray-darkest shadow-sm`}
        >
            <span className='rioglyph rioglyph-time text-24 text-primary' />
            <p className={styles.Clock__time}>{formatTime(datetime, timePattern)}</p>
        </div>
    );
};

export default Clock;
